(function () {
  'use strict';

  var toastTimer = null;

  function showToast(message) {
    var wrap = document.querySelector('[data-sa-toast-wrap]');
    if (!wrap) return;
    var text = wrap.querySelector('[data-sa-toast-text]');
    if (text) text.textContent = message;
    wrap.hidden = false;
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      wrap.hidden = true;
    }, 2600);
  }

  window.SA = window.SA || {};
  window.SA.showToast = showToast;

  function defaultFormatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  /* Mirrors Shopify's classic Shopify.formatMoney helper against shop.money_format. */
  function moneyFromCents(cents) {
    var format = window.SA && window.SA.moneyFormat;
    if (!format) return defaultFormatMoney(cents);
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return defaultFormatMoney(cents);
    switch (match[1]) {
      case 'amount':
        value = (cents / 100).toFixed(2);
        break;
      case 'amount_no_decimals':
        value = String(Math.round(cents / 100));
        break;
      case 'amount_with_comma_separator':
        value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d)(?=[,.]))/g, '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      default:
        value = (cents / 100).toFixed(2);
    }
    if (match[1] === 'amount' || match[1] === 'amount_no_decimals') {
      value = value.replace(/\B(?=(\d{3})+(?!\d)(?=\.|$))/g, ',');
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-sa-nav-toggle]');
    var nav = document.querySelector('[data-sa-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------- Cookie banner ---------- */
  function initCookieBanner() {
    var banner = document.querySelector('[data-sa-cookie-banner]');
    if (!banner) return;
    try {
      if (localStorage.getItem('sa-cookie') !== '1') banner.hidden = false;
    } catch (e) {
      banner.hidden = false;
    }
    var accept = document.querySelector('[data-sa-cookie-accept]');
    if (accept) {
      accept.addEventListener('click', function () {
        try { localStorage.setItem('sa-cookie', '1'); } catch (e) {}
        banner.hidden = true;
      });
    }
  }

  /* ---------- Search overlay ---------- */
  function initSearch() {
    var overlay = document.querySelector('[data-sa-search-overlay]');
    if (!overlay) return;
    var openBtns = document.querySelectorAll('[data-sa-search-open]');
    var closeBtns = document.querySelectorAll('[data-sa-search-close]');
    var input = overlay.querySelector('[data-sa-search-input]');
    var resultsEl = overlay.querySelector('[data-sa-search-results]');
    var emptyEl = overlay.querySelector('[data-sa-search-empty]');
    var idleEl = overlay.querySelector('[data-sa-search-idle]');
    var debounceT = null;
    var controller = null;

    function open() {
      overlay.hidden = false;
      if (input) {
        input.value = '';
        setTimeout(function () { input.focus(); }, 30);
      }
      resultsEl.hidden = true;
      emptyEl.hidden = true;
      idleEl.hidden = false;
      resultsEl.innerHTML = '';
    }
    function close() {
      overlay.hidden = true;
    }

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    function renderResults(products, query) {
      if (!products.length) {
        resultsEl.hidden = true;
        idleEl.hidden = true;
        emptyEl.hidden = false;
        emptyEl.textContent = 'No products match “' + query + '.” Try a different word, or browse the full Shop.';
        return;
      }
      idleEl.hidden = true;
      emptyEl.hidden = true;
      resultsEl.hidden = false;
      resultsEl.innerHTML = products.map(function (p) {
        var img = p.image || (p.featured_image && (p.featured_image.url || p.featured_image)) || '';
        var category = p.type || p.product_type || p.vendor || '';
        var price = p.price;
        return (
          '<a href="' + p.url + '" class="sa-search-result">' +
            '<div class="sa-search-result__thumb">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '">' : '') + '</div>' +
            '<div style="flex:1; text-align:left;">' +
              '<div class="sa-search-result__name">' + escapeHtml(p.title) + '</div>' +
              '<div class="sa-search-result__cat">' + escapeHtml(category) + '</div>' +
            '</div>' +
            '<div class="sa-search-result__price">' + escapeHtml(String(price)) + '</div>' +
          '</a>'
        );
      }).join('');
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounceT);
        if (!q) {
          resultsEl.hidden = true;
          emptyEl.hidden = true;
          idleEl.hidden = false;
          return;
        }
        debounceT = setTimeout(function () {
          if (controller) controller.abort();
          controller = new AbortController();
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show', { signal: controller.signal })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              renderResults(products, q);
            })
            .catch(function (err) {
              if (err.name !== 'AbortError') renderResults([], q);
            });
        }, 250);
      });
    }
  }

  /* ---------- Cart (ajax) ---------- */
  function updateCartCountBadge(count) {
    var badge = document.querySelector('[data-sa-cart-count]');
    if (!badge) return;
    badge.textContent = count > 0 ? String(count) : '';
    badge.hidden = count === 0;
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCountBadge(cart.item_count);
        showToast('Added to cart');
      })
      .catch(function (err) {
        showToast(err.message || 'Could not add to cart');
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }

  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sa-add-to-cart]');
      if (!btn) return;
      var select = document.querySelector('[data-sa-variant-select]');
      var variantId = select ? select.value : btn.getAttribute('data-variant-id');
      addToCart(variantId, btn);
    });
  }

  function initVariantSelect() {
    var select = document.querySelector('[data-sa-variant-select]');
    if (!select) return;
    var priceEl = document.querySelector('[data-sa-product-price]');
    var addBtn = document.querySelector('[data-sa-add-to-cart]');
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var price = opt.getAttribute('data-price');
      if (priceEl && price) priceEl.textContent = moneyFromCents(parseInt(price, 10));
      if (addBtn) addBtn.setAttribute('data-variant-id', select.value);
    });
  }

  /* ---------- Cart page qty/remove ---------- */
  function initCartPage() {
    var grid = document.querySelector('[data-sa-cart-lines]');
    if (!grid) return;

    function changeQty(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCountBadge(cart.item_count);
          if (cart.item_count === 0) {
            window.location.reload();
            return;
          }
          var line = grid.querySelector('[data-sa-cart-line][data-key="' + key + '"]');
          var item = cart.items.filter(function (i) { return i.key === key; })[0];
          if (!item) {
            if (line) line.remove();
          } else if (line) {
            line.querySelector('[data-sa-qty-val]').textContent = item.quantity;
            line.querySelector('[data-sa-line-total]').textContent = moneyFromCents(item.original_line_price);
          }
          var subtotalEl = document.querySelector('[data-sa-cart-subtotal]');
          var totalEl = document.querySelector('[data-sa-cart-total]');
          if (subtotalEl) subtotalEl.textContent = moneyFromCents(cart.total_price);
          if (totalEl) totalEl.textContent = moneyFromCents(cart.total_price);
        })
        .catch(function () {
          showToast('Could not update cart');
        });
    }

    grid.addEventListener('click', function (e) {
      var incBtn = e.target.closest('[data-sa-qty-inc]');
      var decBtn = e.target.closest('[data-sa-qty-dec]');
      var removeBtn = e.target.closest('[data-sa-cart-remove]');
      if (incBtn) {
        var lineInc = incBtn.closest('[data-sa-cart-line]');
        var currentInc = parseInt(lineInc.querySelector('[data-sa-qty-val]').textContent, 10);
        changeQty(incBtn.getAttribute('data-key'), currentInc + 1);
      } else if (decBtn) {
        var lineDec = decBtn.closest('[data-sa-cart-line]');
        var currentDec = parseInt(lineDec.querySelector('[data-sa-qty-val]').textContent, 10);
        changeQty(decBtn.getAttribute('data-key'), currentDec - 1);
      } else if (removeBtn) {
        changeQty(removeBtn.getAttribute('data-key'), 0);
      }
    });
  }

  /* ---------- Collection sort (native Shopify sort_by, just auto-submits) ---------- */
  function initSortForm() {
    var select = document.querySelector('[data-sa-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      select.form.submit();
    });
  }

  /* ---------- Customer address book ---------- */
  function initAddressBook() {
    var showBtn = document.querySelector('[data-sa-show-new-address]');
    var panel = document.querySelector('[data-sa-new-address]');
    if (showBtn && panel) {
      showBtn.addEventListener('click', function () {
        panel.style.display = 'block';
        showBtn.style.display = 'none';
      });
    }
    document.querySelectorAll('[data-sa-confirm]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!window.confirm(btn.getAttribute('data-sa-confirm'))) {
          e.preventDefault();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initCookieBanner();
    initSearch();
    initAddToCart();
    initVariantSelect();
    initCartPage();
    initSortForm();
    initAddressBook();
  });
})();
